import { CartActionType, CartModel, Set_Cart } from "./cart.models";

export function SetCart(payload: CartModel): CartActionType {
  return {
    type: Set_Cart,
    payload
  };
}

